/** @format */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Check from '@material-ui/icons/Check';
import CheckBox from '@material-ui/core/Checkbox';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import I18n from '../../components/Translate/I18n';

class CheckBoxSimple extends PureComponent {
    render() {
        const { classes, checked, label, callback, disabled } = this.props;
        return (
            <FormControlLabel
                control={
                    <CheckBox
                        tabIndex="-1"
                        color={'primary'}
                        disabled={disabled}
                        onClick={(e) => {
                            if (callback) {
                                callback(e.target.checked);
                            }
                        }}
                        checked={checked}
                    />
                }
                disabled={disabled}
                classes={{ label: classes.label }}
                label={<I18n trans={label} />}
            />
        );
    }
}

CheckBoxSimple.propTypes = {
    classes: PropTypes.object.isRequired,
    checked: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export default withStyles(adescomStyle)(CheckBoxSimple);
